// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".part-pic-gif[data-v-186cf8b2]{position:relative;width:100%;height:100%}.game-guide[data-v-186cf8b2]{position:absolute;bottom:0;right:0;z-index:1;overflow:hidden;pointer-events:none}.bubble[data-v-186cf8b2],.game-guide[data-v-186cf8b2]{width:100%;height:100%}.bubble[data-v-186cf8b2]{display:flex;justify-content:center}.lottie[data-v-186cf8b2]{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
